<template>
  <div
    class="w-full flex flex-col gap-4 p-5 rounded-[20px] border border-border"
  >
    <div class="flex items-center gap-2">
      <Switch v-model="local" />
      <p class="text-sm font-medium text-foreground">
        {{ item.name || item.title || item.label }}
      </p>
    </div>

    <div v-if="local" class="flex flex-col gap-2">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
import Switch from "@/shared/ui/switch/Switch.vue";

export default {
  components: { Switch },
  props: ["item", "form"],
  data() {
    return {
      local: this.item.value ?? false,
    };
  },
  watch: {
    local(val) {
      this.$emit("update", this.item.key, val);
    },
  },
};
</script>
